import * as React from 'react';
import Colors from '../../constants/Colors';
import { NavLink } from 'react-router-dom';
import Routes from '../../constants/Routes';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faThLarge, faCalculator, faChartPie, faBookmark } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';

const StyledDashNav = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: repeat(auto-fill, 150px);
  background: ${Colors.black};
`;

const StyledNavLink = styled(NavLink)`
  display: grid;
  color: #aaa;
  grid-auto-flow: column;
  align-content: center;
  justify-content: center;
  background: ${Colors.deepBlueGray};
  text-decoration: none;
  &.active {
    color: #fff;
  }
`;

const NavText = styled.span`
  padding-left: 10px;
`;

const DashNav: React.SFC = () => (
  <StyledDashNav>
    <StyledNavLink to={Routes.main}>
      <FontAwesomeIcon icon={faThLarge} /> <NavText>Dashboard</NavText>
    </StyledNavLink>
    <StyledNavLink to={Routes.favorites}>
      <FontAwesomeIcon icon={faBookmark} /> <NavText>Favorites</NavText>
    </StyledNavLink>
    <StyledNavLink to={Routes.portfolio}>
      <FontAwesomeIcon icon={faChartPie} /> <NavText>Portfolio</NavText>
    </StyledNavLink>
    <StyledNavLink to={Routes.calculator}>
      <FontAwesomeIcon icon={faCalculator} /> <NavText>Calculator</NavText>
    </StyledNavLink>
  </StyledDashNav>
);

export default DashNav;



// WEBPACK FOOTER //
// ./src/containers/Site/DashNav.tsx